import React, { useEffect, useState, useRef } from 'react';
import { BsFillStarFill } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/auth';
import { useToast } from '../hooks/toast';
import { userStatus } from '../enums/userStatus';
import { colorStatus as colorButtonStatus } from '../constant/constant';
import api from '../services/apiClient';

import UserPerfil from './UserPerfil/UserPerfil';
import StatusUserHeader from './StatusUserHeader/StatusUserHeader';
import { getInitials } from '../services/function';

const HeaderMenu: React.FC<any> = () => {
  const {
    registerUserStatus,
    dataConnection,
    signOut,
    reconnect,
    nameUser,
    setNameUser,
    setCorUser,
  } = useAuth();
  const navigate = useNavigate();
  const [showStatus, setShowStatus] = useState(false);
  const refButtonStatus = useRef<HTMLButtonElement>(null);
  const [status, setStatus] = useState(0);
  const [offline, setOffline] = useState(false);
  const [showUserPerfil, setShowUserPerfil] = useState(false);
  const [nameInitials, setNameInitials] = useState('');
  const [newAvaliacao, setNewAvaliacao] = useState(false);

  const { addToast } = useToast();

  const handleStatus = (): void => {
    setShowStatus(!showStatus);
  };

  const handleChangeStatus = (newStatus: userStatus): void => {
    setShowStatus(false);
    setShowUserPerfil(false);

    if (newStatus === status) return;

    setStatus(newStatus);
    localStorage.setItem('@LiveChat:userStatus', newStatus.toString());

    registerUserStatus(
      String(dataConnection.token),
      String(dataConnection.hubConnection?.connectionId),
      newStatus
    );

    if (refButtonStatus.current !== null) {
      refButtonStatus.current.style.backgroundColor =
        colorButtonStatus[newStatus];
    }
  };

  const handlerLogout = (): void => {
    signOut();
    window.location.href = '/';
  };

  useEffect(() => {
    setOffline(dataConnection.hubConnection === undefined);

    dataConnection.hubConnection?.on('UserLogout', () => {
      signOut();
      window.location.href = '/';
    });

    dataConnection.hubConnection?.on(
      'ChangeUserStatus',
      (newStatus: number) => {
        setStatus(newStatus);
        localStorage.setItem('@LiveChat:userStatus', newStatus.toString());

        registerUserStatus(
          String(dataConnection.token),
          String(dataConnection.hubConnection?.connectionId),
          newStatus
        );

        if (refButtonStatus.current !== null) {
          refButtonStatus.current.style.backgroundColor =
            colorButtonStatus[newStatus];
        }

        addToast({
          type: 'warning',
          title: 'Atenção',
          description: 'O seu status foi alterado pelo administrador.',
        });
      }
    );

    dataConnection.hubConnection?.on('NewFeedback', (newFeedback: boolean) => {
      setNewAvaliacao(newFeedback);
    });
  }, [dataConnection.hubConnection]);

  const loadNewAvaliacao = (): void => {
    const token = localStorage.getItem('@LiveChat:token');

    api
      .get('/AvaliacaoAtendimento/new', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const { success } = response.data;

        if (success) {
          setNewAvaliacao(response.data.data);
        } else {
          setNewAvaliacao(false);
        }
      })
      .catch((err) => {
        setNewAvaliacao(false);
      });
  };

  useEffect(() => {
    const { hubConnection } = dataConnection;
    if (hubConnection === undefined) {
      reconnect();
    }

    const statusUserLogin = Number(
      localStorage.getItem('@LiveChat:userStatus')
    );
    setStatus(statusUserLogin);

    if (refButtonStatus.current !== null) {
      refButtonStatus.current.style.backgroundColor =
        colorButtonStatus[statusUserLogin];
    }
  }, []);

  useEffect(() => {
    const name = localStorage.getItem('@LiveChat:nameUser');
    const corUser = localStorage.getItem('@LiveChat:corUser');

    if (name !== null) {
      setNameUser(name);
      setNameInitials(getInitials(name));
    }

    if (corUser !== null) {
      setCorUser(corUser);
    }

    loadNewAvaliacao();
  }, []);

  return (
    <div
      className="d-flex align-items-center justify-content-end position-relative me-3"
      style={{ height: '4.6rem' }}
    >
      <div className="d-flex pt-2 justify-content-end me-4">
        <h5 className="fw-bold text-warning">
          {offline ? ' A conexão com o servidor foi perdida' : ''}
        </h5>
      </div>
      <div className="d-flex align-items-center justify-content-end position-relative">
        <div
          role="button"
          onClick={() => navigate('/Feedback?principal=true')}
          tabIndex={0}
          onKeyPress={() => {
            console.log('clicado');
          }}
        >
          <BsFillStarFill
            className="me-2"
            style={{
              color: newAvaliacao ? '#F5CE00' : '#CED4DA',
              height: '1.75rem',
              width: '1.75rem',
            }}
          />
        </div>
        <StatusUserHeader
          setShowUserPerfil={setShowUserPerfil}
          showUserPerfil={showUserPerfil}
          status={status}
          nameInitials={nameInitials}
        />
      </div>
      <div
        className={`position-absolute ${showUserPerfil ? 'd-block' : 'd-none'}`}
        style={{ top: '4.8rem' }}
      >
        <UserPerfil
          setShowUserPerfil={setShowUserPerfil}
          showUserPerfil={showUserPerfil}
          handleChangeStatus={handleChangeStatus}
          handlerLogout={handlerLogout}
          nameInitials={nameInitials}
          nameUser={nameUser}
        />
      </div>
    </div>
  );
};

export default HeaderMenu;
